import {useEffect, useState} from 'react';
import {Observable} from 'rxjs';

export const useObservable = <T, >(ob$: Observable<T>, initialValue: T): T => {
    const [value, setValue] = useState<T>(initialValue);
    useEffect(() => {
        const subscription = ob$.subscribe(setValue);
        return () => subscription.unsubscribe();
    }, [ob$]);
    return value;
};
